const DataRestoreApiUrls = {
  ACE_HIGHWAY_DR: ` ${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/data-restore/restore`,
  EHBL_DR: ` ${process.env.REACT_APP_USER_EHBL_URL}/ehbl/data-restore/restore`,
  SHARED_DR: ` ${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/data-restore/restore`,
  ACE_OCEAN_DR: ` ${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/data-restore/restore`,
  ACI_OCEAN_DR: ` ${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/data-restore/restore`,
  ACI_HIGHWAY_DR: ` ${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/data-restore/restore`,
  FDAPN_DR: ` ${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/data-restore/restore`,
  AES_DR: ` ${process.env.REACT_APP_USER_AES_URL}/aes/data-restore/restore`,
  ACI_AIR_DR: ` ${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/data-restore/restore`,
  ACE_ISF_DR: ` ${process.env.REACT_APP_USER_ACE_ISF_URL}/ace-isf/data-restore/restore`,
  SUBMIT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/data-restore/submit`,
  GET_TPR_USER: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/get`,
  GET_TPR_USER_PREFERENCE: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user-preference/get`,
  GET_TPR_USER_DETAILS: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/detail/get`
};
  
  export default DataRestoreApiUrls
  